"use client";

import { useEffect, useState } from "react";
import Link from "next/link";
import { Sparkles, Heart, ArrowRight } from "lucide-react";
import { useUser } from "@/lib/user-context";
import { listFavorites } from "@/lib/auth-api";
import { wikiLink } from "@/lib/url";

export function PersonalizedSection() {
  const { me, loading } = useUser();
  const [favorites, setFavorites] = useState<string[]>([]);

  useEffect(() => {
    if (!me?.user) return;
    listFavorites()
      .then((data) => {
        setFavorites(data.favorites.map((f) => f.target_id).slice(0, 6));
      })
      .catch(() => {});
  }, [me]);

  if (loading) return null;

  // 비로그인 — 가입 유도 배너
  if (!me?.user) {
    return (
      <section className="px-5 py-4">
        <Link
          href="/signup"
          className="gradient-primary-soft flex items-center gap-4 rounded-2xl border border-violet-100 p-5 transition-all hover:shadow-md"
        >
          <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-violet-100">
            <Sparkles className="h-6 w-6 text-violet-600" />
          </div>
          <div className="min-w-0 flex-1">
            <p className="text-sm font-bold text-violet-800">맞춤 시술 추천 받기</p>
            <p className="mt-0.5 text-xs text-violet-600/70">
              가입하면 관심사 기반 추천을 받을 수 있어요
            </p>
          </div>
          <ArrowRight className="h-5 w-5 shrink-0 text-violet-400" />
        </Link>
      </section>
    );
  }

  // 로그인 + 즐겨찾기 없음
  if (favorites.length === 0) return null;

  // 로그인 + 즐겨찾기 있음 — 즐겨찾기 시술 표시
  return (
    <section className="px-5 py-6">
      <div className="mb-3 flex items-center justify-between">
        <h2 className="flex items-center gap-2 text-base font-bold">
          <Heart className="h-4 w-4 fill-current text-red-400" />내 즐겨찾기
        </h2>
        <Link href="/account" className="text-xs font-medium text-violet-600 hover:underline">
          전체 보기
        </Link>
      </div>
      <div className="scrollbar-none -mx-5 flex gap-2 overflow-x-auto px-5 pb-1">
        {favorites.map((title) => (
          <Link
            key={title}
            href={wikiLink(title)}
            className="shrink-0 rounded-full border border-red-100 bg-red-50/50 px-4 py-2 text-sm font-medium text-red-700 transition-colors hover:border-red-200 hover:bg-red-50"
          >
            {title}
          </Link>
        ))}
      </div>
    </section>
  );
}
